import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-performance-card.css.lit';
import { OutlineContentCard } from '../../base/outline-content-card/outline-content-card';
import { classMap } from 'lit/directives/class-map.js';
import '../idb-status-icon/idb-status-icon';
interface Indicator {
  label: string;
  value: string;
  status: string;
  icon: string;
}

/**
 * The IDB Performance Card component.
 * @element idb-performance-card
 * @extends OutlineContentCard
 */
@customElement('idb-performance-card')
export class IdbPerformanceCard extends OutlineContentCard {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Array, attribute: 'indicators' })
  indicators: Indicator[] = [];

  firstUpdated(): void {
    this.hasEyebrowSlot = this.slots.test('eyebrow');
    this.hasTitleSlot = this.slots.test('title');
  }

  render(): TemplateResult {
    const cardClasses = {
      'card': true,
      'outline-shadow': this.hasShadow,
      'outline-rounded-2xl': this.isRounded,
      [`outline-bg-${this.cardBackground}`]: this.cardBackground !== undefined,
    };

    const contentWrapperClasses = {
      'card-content-wrapper': true,
    };

    const titleClasses = {
      'card-title': true,
    };

    const eyebrowClasses = {
      'card-eyebrow': true,
    };
    const indicatorsClasses = {
      'card-indicators': true,
    };

    return html`
      <section class="${classMap(cardClasses)}">
        <section class="${classMap(contentWrapperClasses)}">
          <section class="info">
            ${this.eyebrowTemplate(eyebrowClasses)}
            ${this.titleTemplate(titleClasses)}
          </section>
          <section class="${classMap(indicatorsClasses)}">
            ${this.indicators.map(current => {
              return html`
                  <div class="indicator">
                    <div class="label">
                      <span>${current.label}</span>
                    </div>
                    <idb-status-icon value="${current.value}" status="${current.status}" icon="${current.icon}"></idb-status-icon>
                  </div>`;
            })}
          </section>
        </section>
      </section>
    `;
  }
}
